import { FilterState } from "./formatFilterState";
import {
  getAccommodationTypeStatus,
  getAmberSaleStatus,
  getAmenitiesStatus,
  getAvailabilityStatus,
  getBillsIncludedStatus,
  getBudgetAppliedStatus,
  getCancellationPolicyStatus,
  getDistanceFromCityCenterStatus,
  getDualOccupancyStatus,
  getGuarantorStatus,
  getHousingTypeStatus,
  getMoveInMonthAppliedStatus,
  getRoomTypeAppliedStatus,
  getStayDurationAppliedStatus,
} from "./getFilterActiveStatus";

const getAllFilterCount = (filtersState: any): number => {
  const allStatus = [
    getBudgetAppliedStatus,
    getMoveInMonthAppliedStatus,
    getStayDurationAppliedStatus,
    getRoomTypeAppliedStatus,
    getAvailabilityStatus,
    getDualOccupancyStatus,
    getAccommodationTypeStatus,
    getGuarantorStatus,
    getDistanceFromCityCenterStatus,
    getHousingTypeStatus,
    getAmenitiesStatus,
    getBillsIncludedStatus,
    getAmberSaleStatus,
    getCancellationPolicyStatus,
  ];

  const allCount: number = allStatus.reduce(
    (acc: number, it: (filterState: FilterState) => boolean) =>
      Number(it.call(this, filtersState)) + acc,
    0,
  );

  return allCount;
};

export default getAllFilterCount;
